<template>
  <div class="home-container">
    <!-- 背景音乐 -->
    <audio ref="bgMusic" loop class="bg-music">
      <source
        src="https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260303/20260303161508.mp3"
        type="audio/mpeg"
      />
    </audio>

    <!-- 音乐控制按钮 -->
    <div
      class="music-control"
      :class="{ playing: isPlaying }"
      @click="toggleMusic"
    >
      <img
        :src="isPlaying ? musicPlayingIcon : musicPausedIcon"
        alt="音乐控制"
        class="music-icon"
      />
    </div>

    <!-- 登录组件 -->
    <login v-if="!isLoggedIn" @login-success="handleLoginSuccess" />

    <!-- 详情组件 -->
    <detail v-else />
  </div>
</template>

<script>
import Login from './login.vue'
import Detail from './detail.vue'

export default {
  components: {
    Login,
    Detail
  },
  data() {
    return {
      isLoggedIn: false,
      isPlaying: false,
      musicPlayingIcon:
        'https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260303/musicPlay&12159&20260303115152.png',
      musicPausedIcon:
        'https://elife-dev.oss-cn-shanghai.aliyuncs.com/20260303/musicPaused&9453&20260303115736.png'
    }
  },
  mounted() {
    if (sessionStorage.getItem('ydGrilsDayToken')) {
      this.isLoggedIn = true
    }
  },
  methods: {
    handleLoginSuccess() {
      this.isLoggedIn = true
    },
    toggleMusic() {
      const audio = this.$refs.bgMusic
      if (audio) {
        if (this.isPlaying) {
          audio.pause()
        } else {
          audio.play().catch(error => {
            console.log('音频播放失败:', error)
          })
        }
        this.isPlaying = !this.isPlaying
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.music-control {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(0deg);

  &.playing {
    animation: rotate 3s linear infinite;
  }

  .music-icon {
    width: 24px;
    height: 24px;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
